// extracted by mini-css-extract-plugin
module.exports = {"icomoon-font":"NumberInput_icomoon-font__3B9Sb","NumberInput":"NumberInput_NumberInput__2zoAF"};